import React, { useState } from "react"
import { connect } from "react-redux"
import { receive, showMiniCart } from "../Actions/Cart.action"
import { add } from "../Services/Cart.service"
import { translate } from "../Services/translation"

const ProductCardQuickAdd = ({ children, sizeModels, sizeHint, sizeHintShort, addToCart, sizeHintValue, shouldShowMiniCartOnAdd = true, algoliaQueryId = '' }) => {
    const [loading, setLoading] = useState({});
    const [completed, setCompleted] = useState({});

    const onSizeClick = (e, sizeModel, index) => {

        e.preventDefault()
        if (sizeModel.isInStock == "true" || sizeModel.isInStock === true) {
            setLoading({ ...loading, [index]: true });
            setCompleted({ ...completed, [index]: false });
            addToCart(sizeModel.articleNumber, shouldShowMiniCartOnAdd, algoliaQueryId).then(() => {

                setLoading(oldLoadingState => ({ ...oldLoadingState, [index]: false }));
                setCompleted(oldCompletedState => ({ ...oldCompletedState, [index]: true }));
                setTimeout(() => {
                    setCompleted(oldCompletedState => ({ ...oldCompletedState, [index]: false }));
                }, 2000);
            });
        }
    }

    return <div className="product__quick-add">
        <span className="product__quick-add--title">{translate("product.quick.add")}</span>
        <ul>
            {sizeModels.map((sizeModel, index) => <li key={`qa_${sizeModel.articleNumber}`} className={`${sizeModel.isInStock == "false" || sizeModel.isInStock == false ? "unavailable" : ''} ${loading[index] ? 'is-loading' : ''} ${completed[index] ? 'is-completed' : ''}`}>
                <a className="product__quick-add__item-label" onClick={e => onSizeClick(e, sizeModel, index)}>{sizeModel.size}</a>
                <div className="product__quick-add__loading"><i className="ph-arrow-clockwise spin"></i></div>
                <div className="product__quick-add__completed"><i className="ph-check completed"></i></div>
            </li>)}
        </ul>
        {sizeHintValue != 1 && sizeHintShort && <span className="product__quick-add--extra-info">{sizeHintShort}</span>}
        {children}
    </div>
}

const mapDispatchToProps = dispatch => ({
    addToCart: async (articleNumber, shouldShowMiniCartOnAdd, algoliaQueryId = '') => {
        dispatch(receive(await add(articleNumber, 1, 'ProductCardQuickAdd', algoliaQueryId)))
        if (shouldShowMiniCartOnAdd) {
            dispatch(showMiniCart())
        }
    }
})

export default connect(null, mapDispatchToProps)(ProductCardQuickAdd)